import { render, staticRenderFns } from "./BillGiftModal.vue?vue&type=template&id=48bab72a"
import script from "./BillGiftModal.vue?vue&type=script&lang=js"
export * from "./BillGiftModal.vue?vue&type=script&lang=js"
import style0 from "./BillGiftModal.vue?vue&type=style&index=0&id=48bab72a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports